/**
 * Utility function to get proxied URL for images
 * Only applies proxy for non-HTTPS URLs
 * @param {string} url - The original image URL
 * @returns {string} - The proxied URL or original URL
 */
export function getProxiedUrl(url) {
  if (!url) return '';

  if (
    url.startsWith('https://') ||
    url.startsWith('data:') ||
    url.startsWith('blob:') ||
    url.startsWith('/')
  ) {
    return url;
  }

  if (url.startsWith('http://')) {
    return `https://images.weserv.nl/?url=${encodeURIComponent(url)}`;
  }

  return url;
}

/**
 * Utility function to get the first image from an array with proxy support
 * @param {Array} images - Array of image URLs
 * @returns {string} - The first image URL with proxy if needed
 */
export function getFirstImage(images) {
  if (!images || !Array.isArray(images) || images.length === 0) {
    return '';
  }
  return getProxiedUrl(images[0]);
} 